import { type AIAgentStreamingConfig } from '../models/AIAgentStreamingConfig';

export const logInfo = (message: string, config: AIAgentStreamingConfig, data: object) => {
	if (config.enableLocalVerboseLogs) {
		// eslint-disable-next-line no-console
		console.info(`[@atlassian/ai-agent-streaming] [${message}]:`, data);
	}
};
